import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Accordion, RowToggleDataTable } from "react-bootstrap";
import "./_hostelAttendance.scss"
import SelectDropDown from '../selectdropdown/SelectDropDown';
import { components } from 'react-select';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import MultiSelect from "react-multi-select-component";
import BuildingCreationModal from "./buildingCreationModal";

class BuildingCreationSection extends Component {
    constructor(props) {
        super();
        this.state = {
            branchSearch: "",
            branchError: "",
            buildingCreationModal: false,
            existingBuildingCreationData: [],
            activeBuildingDetails: null,
            activeFloorDetails: null,
            activeRoomDetails: null,
            activeCapacityDetails: null,
            getBuildingData: [],
            getFloorData: [],
            getRoomData: [],
            loading: 0,
            noDateError: "",
        }
    }
    handleBranchChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "branch") {
            this.setState({
                branchSearch: value,
                branchError: "",
                getBuildingData: [],
                loading: 0,
                noDateError: ""
            })

        }
    }

    getBuildingCreationDetails = async () => {
        const result = await this.props.client.query({
            query: gql`
                query($institute_id: Int!, $branch_id: Int!){
                    getBuildingCreationDetails(institute_id: $institute_id, branch_id:$branch_id) {
                        hostel_building_id
                        hostel_building_name
                        floors_details{
                          hostel_building_floor_id:floor_id
                          floor_name
                          floor_incharge_id
                          rooms_details{
                            room_id
                            room_name
                            room_capacity
                            capacity_details{
                              edu_student_id
                              attendance_status
                              attended_date
                            }
                          }
                        }
                    }
                }
                `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branchSearch)
            },
            fetchPolicy: 'network-only'
        })

        console.log("ss", result.data.getBuildingCreationDetails);
        if (result.data.getBuildingCreationDetails.length > 0) {
            let filter_data = result.data.getBuildingCreationDetails
            this.setState({
                getBuildingData: filter_data,
                loading: 0
            })

        } else {
            this.setState({ loading: 0, getBuildingData: [], noDateError: "No Data Available" })

        }
    }

    handleAccordionClick1 = (item, name) => {

        console.log("item", item);

        if (name == "building") {
            if (this.state.activeBuildingDetails == item.hostel_building_id) {
                this.setState({ activeBuildingDetails: null, activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getFloorData: [], getRoomData: [], getStudentData: [] });
            } else if (this.state.activeBuildingDetails != null && this.state.activeBuildingDetails != item.hostel_building_id) {
                const floorData = this.state.getBuildingData.filter((a) => a.hostel_building_id === item.hostel_building_id)[0].floors_details;
                this.setState({ activeBuildingDetails: item.hostel_building_id, activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getFloorData: floorData, getRoomData: [], getStudentData: [] });
            } else {
                const floorData = this.state.getBuildingData.filter((a) => a.hostel_building_id === item.hostel_building_id)[0].floors_details;
                console.log("floorData", floorData);
                this.setState({ activeBuildingDetails: item.hostel_building_id, getFloorData: floorData });
            }
        }


        if (name == "floor") {

            if (this.state.activeFloorDetails === item) {
                this.setState({ activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getRoomData: [] });
            } else {

                const roomData = this.state.getFloorData.filter((a) => a.hostel_building_floor_id === item)[0].rooms_details;
                this.setState({ activeFloorDetails: item, getRoomData: roomData });
            }
        }

    };

    handleBranchSubmit = (e) => {
        e.preventDefault();
        if (this.state.branchSearch == "") {
            this.setState({ branchError: "Please select Branch" })
            return ""
        }
        this.setState({ loading: 1 })
        this.getBuildingCreationDetails();
    }


    render() {
        console.log("maheshparent1", this.state);
        console.log("maheshparent2", this.props);

        if (this.props.studentCreationModal) {
            this.state.buildingCreationModal = true
        }
        return (
            <Container>
                <Row className="mt-4">
                    <Col sm={12}>
                        <Form.Group controlId="StartDate" style={{ display: "flex", justifyContent: "end", marginBottom: "-13px" }}>
                            <button className="building_Creation h6" onClick={() => this.setState({ buildingCreationModal: true, existingBuildingCreationData: [] })}>Building Creation</button>
                        </Form.Group>
                    </Col>
                </Row>

                {/* <hr className="bg-dark" /> */}

                <Row className="mt-2">
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                    <Form.Label className="text-uppercase font-weight-bold">Select Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleBranchChange} value={this.state.branchSearch}>
                                        <option value="">--Select Branch--</option>
                                        {this.props.globals.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                    <button className="btn text-uppercase submit_btn btn-color-2" onClick={this.handleBranchSubmit}>
                                        Submit</button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>
                {
                    this.state.getBuildingData.length > 0 ? (
                        <>
                            <Card style={{ backgroundColor: "#f8f9fa", cursor: "pointer", border: "none" }}>
                                <Card.Body>
                                    <Card >
                                        <Accordion>
                                            {this.state.getBuildingData.map((item, index) => {
                                                return (
                                                    <Card key={index}>
                                                        <Accordion.Toggle
                                                            className="building_bg"
                                                            as={Card.Header}
                                                            eventKey={index.toString()}
                                                            onClick={() => this.handleAccordionClick1(item, "building")}
                                                        >
                                                            <Row>
                                                                <Col as={Col} lg={1} md={12} sm={12}>
                                                                    {this.state.activeBuildingDetails === item.hostel_building_id ?
                                                                        <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                                                        :
                                                                        <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                                                    }
                                                                </Col>
                                                                <Col as={Col} lg={3} md={12} sm={12}>
                                                                    <div>{item.hostel_building_name}</div></Col>
                                                                <Col as={Col} lg={2} md={12} sm={12}> <div>Floors : {item.floors_details.length}</div></Col>
                                                                <Col as={Col} lg={2} md={12} sm={12}>
                                                                    <div>Rooms  : {
                                                                        item.floors_details.reduce((totalRooms, floor) => {
                                                                            return totalRooms + (floor.rooms_details ? floor.rooms_details.length : 0);
                                                                        }, 0)
                                                                    }</div>
                                                                </Col>
                                                                <Col as={Col} lg={2} md={12} sm={12}>
                                                                    <div>Capacity : {
                                                                        item.floors_details.reduce((totalCapacity, floor) => {
                                                                            return totalCapacity + (floor.rooms_details ? floor.rooms_details.reduce((roomCapacity, room) => {
                                                                                return roomCapacity + (room.room_capacity ? room.room_capacity : 0);
                                                                            }, 0) : 0);
                                                                        }, 0)
                                                                    }</div>
                                                                </Col>
                                                                <Col as={Col} lg={2} md={12} sm={12}>
                                                                    <div>
                                                                        <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ buildingCreationModal: true, existingBuildingCreationData: [item] })}>
                                                                            <Button variant="link" name="edit" className="text-theme">
                                                                                <i className="far fa-edit" style={{ color: "black" }} />
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </Col>

                                                            </Row>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey={index.toString()}>
                                                            <Card.Body className="building_bg">
                                                                {item.floors_details.map((floor, floorIndex) => (
                                                                    <Accordion key={index} activeKey={this.state.activeFloorDetails}>
                                                                        <Card>
                                                                            <Accordion.Toggle
                                                                                className="floor_bg"
                                                                                as={Card.Header}
                                                                                eventKey={floor.hostel_building_floor_id}
                                                                                onClick={() => this.handleAccordionClick1(floor.hostel_building_floor_id, "floor")}
                                                                            >
                                                                                <Row>
                                                                                    <Col xl={1} lg={1} md={1} sm={2} xs={2}>
                                                                                        {this.state.activeFloorDetails === floor.hostel_building_floor_id ? (
                                                                                            <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                                                                        ) : (
                                                                                            <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                                                                        )}
                                                                                    </Col>
                                                                                    <Col xl={11} lg={11} md={11} sm={10} xs={10} className="d-flex justify-content-between">
                                                                                        <div>{floor.floor_name}</div>
                                                                                        <div>Rooms : {floor.rooms_details.length}</div>
                                                                                        <div>Room Capacity : {
                                                                                            floor.rooms_details.reduce((totalCapacity, room) => {
                                                                                                return totalCapacity + (room.room_capacity ? room.room_capacity : 0);
                                                                                            }, 0)
                                                                                        }</div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Accordion.Toggle>
                                                                            <Accordion.Collapse eventKey={floor.hostel_building_floor_id}>
                                                                                <Card.Body style={{ backgroundColor: "#dde3e5" }}>
                                                                                    {floor.rooms_details.map((room, roomIndex) => {
                                                                                        let popupshow = false;

                                                                                        return (
                                                                                            <Accordion key={floorIndex} activeKey={this.state.activeRoomDetails}>
                                                                                                <Card>
                                                                                                    <Row className="room_bg" >
                                                                                                        <Col as={Col} lg={4} md={12} sm={12}>
                                                                                                            <div className="mt-3 text-center" style={{ marginBottom: "15px" }}> {room.room_name}</div>
                                                                                                        </Col>
                                                                                                        <Col as={Col} lg={4} md={12} sm={12}>
                                                                                                            <div className="mt-3 text-center" style={{ marginBottom: "15px" }}>Room Capacity : {room.room_capacity}</div>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Card>
                                                                                            </Accordion>
                                                                                        )
                                                                                    }
                                                                                    )}
                                                                                </Card.Body>
                                                                            </Accordion.Collapse>
                                                                        </Card>
                                                                    </Accordion>
                                                                ))}
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                );
                                            })}
                                        </Accordion>
                                    </Card>
                                </Card.Body>
                            </Card>
                        </>
                    ) : (
                        <Row>
                            {
                                <>
                                    <Col sm={12}>
                                        <div className={this.state.loading == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                                    </Col>
                                    <Col sm={12}>
                                        {
                                            this.state.noDateError != "" ? (
                                                <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                            )
                                                :
                                                ("")
                                        }
                                    </Col>
                                </>
                            }
                        </Row>
                    )}


                <BuildingCreationModal
                    stateData={this.state}
                    show={this.state.buildingCreationModal}
                    onHide={() => this.setState({ buildingCreationModal: false })}
                    globals={this.props.globals}
                />
            </Container>
        )
    }
}
export default withRouter(withApollo((BuildingCreationSection)));